import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { CatHeading } from "blocks-nextjs/blocks-react/components/Heading/Heading";
import { CatIconBatteryFull } from "blocks-nextjs/blocks-react/components/Icons/BatteryFull/BatteryFull";
import { CatIconMachineExcavator } from "blocks-nextjs/blocks-react/components/Icons/MachineExcavator/MachineExcavator";
import { CatIconPower } from "blocks-nextjs/blocks-react/components/Icons/Power/Power";
import { CatIconWarningTriangleFilled } from "blocks-nextjs/blocks-react/components/Icons/WarningTriangleFilled/WarningTriangleFilled";
import CHARGEMECCHARGER from "../../assets/CHARGE-MEC-Charger.svg";
import Dozer from "../../assets/Dozer.svg";
import ESS from "../../assets/Ess.svg";
import EssBox from "../../assets/EssBox.svg";
import IDLEMECCHARGER from "../../assets/IDLE-MEC-Charger.svg";
import TruckWithEss from "../../assets/Truck-with-ess.svg";
import wheelLoader from "../../assets/wheel-loader.svg";
import { NodeIconType } from "./CustomNodeEnums";
export const AddAssetNode = (props) => {
    let icon;
    const rightClass = props.data.columnTitle === "Asset #" ? "right-[23px]" : "right-[40px]";
    switch (props.data.iconType) {
        case NodeIconType.EXCAVATOR:
            icon = (_jsx(CatIconMachineExcavator, { className: "items-center justify-center flex", "data-test": "excavator-icon", size: "xl" }));
            break;
        case NodeIconType.TRACTOR:
            icon = (_jsx("span", { className: "items-center justify-center flex", children: _jsx("img", { alt: "Assets", className: "w-8 h-8", src: Dozer }) }));
            break;
        case NodeIconType.ESS:
            icon = (_jsx("span", { className: "items-center justify-center flex", children: _jsx("img", { alt: "Assets", className: "w-8 h-8", src: ESS }) }));
            break;
        case NodeIconType.ESSBOX:
            icon = (_jsx("span", { className: "items-center justify-center flex", children: _jsx("img", { alt: "Assets", className: "w-8 h-8", "data-test": "essbox-icon", src: EssBox }) }));
            break;
        case NodeIconType.TRUCKWITHESS:
            icon = (_jsx("span", { className: "items-center justify-center flex", children: _jsx("img", { alt: "Assets", className: "w-8 h-8", src: TruckWithEss }) }));
            break;
        case NodeIconType.BATTERY:
            icon = _jsx(CatIconBatteryFull, { className: "items-center justify-center flex", size: "xl" });
            break;
        case NodeIconType.POWER:
            icon = _jsx(CatIconPower, { className: "items-center justify-center flex", size: "xl" });
            break;
        case NodeIconType.WHEELLOADER:
            icon = (_jsx("span", { className: "items-center justify-center flex", children: _jsx("img", { alt: "Assets", className: "w-8 h-8", src: wheelLoader }) }));
            break;
        case NodeIconType.IDLEMECCHARGER:
            icon = (_jsx("span", { className: "items-center justify-center flex", children: _jsx("img", { alt: "Assets", className: "w-8 h-8", src: IDLEMECCHARGER }) }));
            break;
        case NodeIconType.CHARGEMECCHARGER:
            icon = (_jsx("span", { className: "items-center justify-center flex", children: _jsx("img", { alt: "Assets", className: "w-8 h-8", src: CHARGEMECCHARGER }) }));
            break;
        case NodeIconType.WARNING:
        default:
            icon = (_jsx(CatIconWarningTriangleFilled, { className: "items-center justify-center flex text-grey-700 fill-current", size: "xl" }));
            break;
    }
    return (_jsx(_Fragment, { children: _jsxs("div", { className: "flex flex-col gap-[2px] p-[10px] border-solid border-2 rounded border-gray-800 w-[108px] h-[92px] text-center content-center text-black box-border", "data-test": "add-asset-node-container", children: [props.data.columnTitle && (_jsx("div", { className: `absolute top-[-55px] ${rightClass} font-semibold text-[25px] tracking-normal text-black whitespace-nowrap`, "data-test": "add-asset-node-column-title", children: props.data.columnTitle })), _jsx(CatHeading, { "data-test": "add-asset-node-label", variant: "title", children: props.data.label }), icon] }) }));
};
